import React from 'react'
import PropTypes from 'prop-types'
import { autobind } from 'core-decorators'
import styled from 'styled-components'

import HeroUnit from 'components/home/hero-unit'
import Statistic from 'components/home/statistic'
import GetStarted from 'components/get-started'
import Convenient from 'components/home/convenient'
import Personalize from 'components/home/personalize'

const HomePageStyle = styled.div``

export default
@autobind
class HomePage extends React.PureComponent {
  static propTypes = {
    heroUnit: PropTypes.shape({
      heading: PropTypes.string,
      content: PropTypes.string,
      button: PropTypes.shape({
        text: PropTypes.string,
        link: PropTypes.string
      })
    }),
    statistic: PropTypes.shape({
      heading: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          icon: PropTypes.shape({
            publicURL: PropTypes.string
          }),
          value: PropTypes.string,
          label: PropTypes.string
        })
      )
    }),
    getStarted: PropTypes.shape({
      heading: PropTypes.string,
      button: PropTypes.shape({
        text: PropTypes.string,
        link: PropTypes.string
      })
    })
  }

  render () {
    const { heroUnit, convenient, personalize, statistic, getStarted } = this.props
    return (
      <HomePageStyle>
        <HeroUnit data={heroUnit} />
        <Convenient data={convenient} />
        {/* <GetStarted data={improveYourKnowledge} /> */}
        <Personalize data={personalize} />
        <Statistic data={statistic} />
        <GetStarted data={getStarted} />
      </HomePageStyle>
    )
  }
}
